import { Fragment } from 'react';

import { Specialty } from '@/lib/types';

import Typography from '@/components/typography';

import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import { TBreadcrumb } from '@/services/schema-service';
import { isNurse } from '@/utils/discipline-utils';

export default function SpecialtyPageBreadcrumb() {
  const { specialty } = useSpecialtyPageContext();

  const breadcrumbs = buildSpecialtyBreadcrumbs(specialty);
  return (
    <div className='w-full'>
      <div className='mb-8 mt-4 flex flex-wrap gap-2'>
        {breadcrumbs.map((item, index) => (
          <Fragment key={item.title}>
            <a href={item.path || '#'}>
              <Typography.TextXSmall className='hover:text-typography-dark'>
                {item.title}
              </Typography.TextXSmall>
            </a>
            {index < breadcrumbs.length - 1 && (
              <Typography.TextXSmall>&gt;</Typography.TextXSmall>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export function buildSpecialtyBreadcrumbs(
  specialty: Specialty | null | undefined
): TBreadcrumb[] {
  const discipline = specialty?.discipline;
  if (!specialty || !discipline) return [];
  const pieces: [TBreadcrumb, ...TBreadcrumb[]] = isNurse(
    discipline.disciplineType
  )
    ? [{ title: 'Nurse', path: '/nurse' }]
    : [
        { title: 'Allied', path: '/allied' },
        { title: 'Travel Allied', path: '/allied/travel-allied' },
      ];
  const lastPiecePath = pieces[pieces.length - 1].path;
  return [
    { title: 'Nomad Health', path: '/' },
    ...pieces,
    { title: discipline.title, path: `${lastPiecePath}/${discipline.slug}` },
    { title: specialty.title },
  ];
}
